import { cn } from "@/primitives/utils"

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      // beacon: an alpha of the foreground, as the hairlines are, so a placeholder reads the same on
      // the panel, a card and a popover in both schemes; the muted fill all but vanished on a dark
      // card or popover.
      className={cn("animate-pulse rounded-md bg-foreground/8", className)}
      {...props}
    />
  )
}

export { Skeleton }
